$(document).ready(function () {

  const checkGWP = async () => {

    try {

      const res = await fetch('/cart.js');
      const cart = await res.json();

      const FREE_GIFT_VARIANT = 54458269925698;
      const REQUIRED_TAG = 'kddsdds';

      let hasTaggedProduct = false;

      // Check tagged products in cart
      for (const item of cart.items) {

        if (item.variant_id == FREE_GIFT_VARIANT) continue;

        const productRes = await fetch(`/products/${item.handle}.js`);
        const product = await productRes.json();

        if (product.tags.includes(REQUIRED_TAG)) {
          hasTaggedProduct = true;
          break;
        }
      }

      const freeItems = cart.items.filter(
        item => item.variant_id == FREE_GIFT_VARIANT
      );

      // Add free gift when tagged product exists
      if (hasTaggedProduct) {

        if (freeItems.length === 0) {

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: FREE_GIFT_VARIANT,
              quantity: 1,
              properties: {
                "Item Type": "Free Gift"
              }
            })
          });

          location.reload();
        }

      } else {

        // Tagged product removed
        // Free gift remains in cart
        // Discount should be removed automatically by Shopify Discount/Function

        console.log('Tagged product removed. Free gift remains in cart at regular price.');

      }

    } catch (error) {

      console.error('GWP Error:', error);

    }

  };

  // checkGWP();

});
















